module.exports = __webpack_public_path__ + "static/img/recommend_product.7d9b120e.png";